import { useEffect } from "react"
import { UseFormReset } from "react-hook-form"
import { useLocation } from "react-router-dom"
import { useTurnoActual } from "src/pages/home/room-detail/hooks/turnos"
import { FormValues } from "./RegistroIncidencia.types"
import { defaultValues } from "./RegistroIncidencia.constants"
import { useCurrentDateLazyQuery } from "src/gql/schema"
import { useDate } from "src/shared/hooks/useDate"

export function useRegistroIncienciaConfig(
    turnos: any[],
    reset: UseFormReset<FormValues>
) {
    const turno = useTurnoActual()
    const location = useLocation()
    const [getDate] = useCurrentDateLazyQuery()
    const { UTCStringToLocalDate } = useDate()

    const fromCortes = location.pathname === "/u/cortes/crear-incidencia"

    useEffect(() => {
        if (turno?.turno_id && fromCortes) {
            getDate().then((d) => {
                reset({
                    ...defaultValues,
                    turn: turno?.turno_id,
                    date: [UTCStringToLocalDate(d.data?.serverDate)],
                })
            })
        }
    }, [turno?.turno_id])

    const getRegisterDate = async (selectedDate?: Date): Promise<string> => {
        const { data } = await getDate()

        if (!selectedDate) return data?.serverDate

        const serverDate = new Date(data?.serverDate)
        const isSameDay =
            selectedDate.getFullYear() === serverDate.getFullYear() &&
            selectedDate.getMonth() === serverDate.getMonth() &&
            selectedDate.getDate() === serverDate.getDate()

        if (isSameDay) return data?.serverDate

        // Para días distintos al actual, usar las 2pm del día seleccionado
        const dateAt2pm = new Date(selectedDate)
        dateAt2pm.setHours(14, 0, 0, 0)
        return dateAt2pm.toISOString()
    }


    return {
        fromCortes,
        getRegisterDate,
    }
}
